<template>
    <form-row title="Is additional money due to Extend?">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-boolean
                name="entitlement_additional_money_is_due"
                v-model="entitlement_additional_money_is_due"
                true="Yes"
                false="No"
                :read_only="read_only"
            />

            <input-money
                v-if="entitlement_additional_money_is_due"
                name="entitlement_additional_money_amount"
                class="sm:ml-12"
                v-model="entitlement_additional_money_amount"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        commercial: {},
        value: {},
        read_only: { default: false },
    },

    data() {
        return {
            entitlement_additional_money_is_due: this.commercial.entitlement_additional_money_is_due,
        }
    },

    computed: {
        entitlement_additional_money_amount: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    },
}
</script>
